import { ChatbotEffects } from './chatbot.effects';

export * from './chatbot.actions';

export const chatbotEffects = [ChatbotEffects];
